<template>
  <div>
    <div style="margin-left: 250px;">
       <el-card>
        <el-card style="margin-bottom: 30px;">课消详情 （老师统计） <i style="position: absolute;right: 60px;font-size: 25px;color: #409EFF;"
           class="el-icon-circle-close" @click="handleReturn"></i></el-card>

        <el-form style="display: flex;flex-wrap: wrap;"  >


              <el-form-item label="课程:" style="display: flex;width: 33%; ">
                <div style=" padding-left: 27px;">
                  <el-select
                    placeholder="请选择课程"
                    v-model="curriculum"
                    style="width: 100%;"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in curriculumArr"
                      :key="item.id"
                      :value="item.id"
                      :label="item.categoryName"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>

              <el-form-item label="线下学员:" style="display: flex;width: 33%;">
                <el-select
                  placeholder="请选择学员"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable
                  @change="studentChange222"
                  :filter-method="handleInput222"
                >
                  <el-option
                    v-for="item in getStudentsArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="规划学员:" style="display: flex;width: 33%;" >
                <el-select
                  placeholder="请选择学员"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable
                  @change="studentChange22"
                  :filter-method="handleInput22"
                >
                  <el-option
                    v-for="item in getStudentsArr_s"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="学生类型:" style="width: 33%; display: flex;">
                <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                  <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="课消状态:" style="display: flex;width: 33%;" >
                <el-select
                  placeholder="请选择课消状态"
                  v-model="coursecancellationStatusInput"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in coursecancellationStatus"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>



              <el-form-item label="日期:" style="display: flex;width: 60%; padding-left: 27px;">
                <el-date-picker
                style="width: 100%;"
                v-model="dateTimeList"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable>
                </el-date-picker>
              </el-form-item>

       </el-form>


       <div style="display: flex;">
              <div style="width: 55%;">
                <div style="display: flex;margin-left: -55px;">
                  <span
                  style="
                    font-weight: 900;

                    width: 400px;
                    background-color: #f58c4b;
                    height: 30px;
                    border-radius: 10px;
                    padding: 5px 0px;
                    margin-bottom: 10px;
                    text-align: start;
                    line-height: 26px;
                    padding-left: 10px;
                    margin-left: 100px;
                    padding-left: 17px;
                  "
                > 实际课消次数:{{ dataTop_s.actualNumCount }} </span>

                <span
                  style="
                    font-weight: 900;

                    width: 400px;
                    background-color: #d1c633;
                    height: 30px;
                    border-radius: 10px;
                    padding: 5px 0px;
                    margin-bottom: 10px;
                    text-align: start;
                    line-height: 26px;
                    padding-left: 10px;
                    margin-left: 100px;
                    padding-left: 17px;
                  "
                > 实际课消金额:{{ dataTop_s.actualMoneyCount }} </span>

                </div>


                <div style="display: flex;margin-left: -55px;">
                  <span
                    style="
                      font-weight: 900;

                      width: 400px;
                      background-color: rgb(150 233 149);
                      height: 30px;
                      border-radius: 10px;
                      padding: 5px 0px;
                      margin-bottom: 10px;
                      text-align: start;
                      line-height: 26px;
                      padding-left: 10px;
                      margin-left: 100px;
                      padding-left: 17px;
                    "
                  > 未课消次数：{{ dataTop_s.notNumCount }} </span>


                  <span
                    style="
                      font-weight: 900;

                      width: 400px;
                      background-color: #c2f54b;
                      height: 30px;
                      border-radius: 10px;
                      padding: 5px 0px;
                      margin-bottom: 10px;
                      text-align: start;
                      line-height: 26px;
                      padding-left: 10px;
                      margin-left: 100px;
                      padding-left: 17px;
                    "
                  > 未课消金额：{{ dataTop_s.notMoneyCount }} </span>
                </div>


                <div style="display: flex;margin-left: -55px;">
                  <span
                    style="
                      font-weight: 900;

                      width: 400px;
                      background-color: #5deb9e;
                      height: 30px;
                      border-radius: 10px;
                      padding: 5px 0px;
                      margin-bottom: 10px;
                      text-align: start;
                      line-height: 26px;
                      padding-left: 10px;
                      margin-left: 100px;
                      padding-left: 17px;
                    "
                  > 预课消总次数：{{ dataTop_s.estimateNumCount }} </span>


                  <span
                    style="
                      font-weight: 900;

                      width: 400px;
                      background-color: #e39a59;
                      height: 30px;
                      border-radius: 10px;
                      padding: 5px 0px;
                      margin-bottom: 10px;
                      text-align: start;
                      line-height: 26px;
                      padding-left: 10px;
                      margin-left: 100px;
                      padding-left: 17px;
                    "
                  > 预课消总金额: {{ dataTop_s.estimateMoneyCount }} </span>

                </div>



              </div>

              <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>
            </div>



      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"
            :cell-style="{'text-align':'center'}"
            :data="dataList" border height="500">
        <el-table-column prop="courseDate" label="日期">
          <template slot-scope="scope">
             <span>{{scope.row.courseDate.substring(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="courseStartTime" label="开始时间"></el-table-column>
        <el-table-column prop="courseEndTime" label="结束时间"></el-table-column>
        <el-table-column prop="subjectName" label="课程"></el-table-column>
        <el-table-column prop="studentName" label="学员"></el-table-column>
        <el-table-column prop="isSales" label="课消状态">
          <template slot-scope="scope">
              <span v-if="scope.row.isSales == 0 ">未课消</span>
              <span v-else-if="scope.row.isSales == 1 ">已课消</span>
              <span v-else>全部</span>
          </template>
        </el-table-column>
        <el-table-column prop="salesNumInternal" label="课消次数"></el-table-column>
        <el-table-column prop="salesMoney" label="课消金额"></el-table-column>

        <el-table-column prop="productClassType" label="班型">
           <template slot-scope="scope">
              <span>{{ scope.row.productClassType === 1 ? "1V1" : scope.row.productClassType === 1 ? "1v2" : scope.row.productClassType === 3 ? '1v3' : '' }}</span>
           </template>
        </el-table-column>
        <el-table-column prop="classPersonType" label="上课人员">
          <template slot-scope="scope">
            <span v-if="scope.row.classPersonType === 1">孩子</span>
            <span v-if="scope.row.classPersonType === 2">孩子和父亲</span>
            <span v-if="scope.row.classPersonType === 3">孩子和母亲</span>
            <span v-if="scope.row.classPersonType === 4">父亲</span>
            <span v-if="scope.row.classPersonType === 5">母亲</span>
            <span v-if="scope.row.classPersonType === 6">父亲和母亲</span>
            <span v-if="scope.row.classPersonType === 7">孩子、父亲、母亲</span>
          </template>
        </el-table-column>
        <el-table-column prop="deductibleProducts" label="课程类别"></el-table-column>
        <el-table-column prop="deductibleProducts" label="扣费产品"></el-table-column>
      </el-table>



      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>


     </el-card>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";

import { ExportExcel, ExportApiExcel } from "../../utils/Export"



import Vue from 'vue';
import { ref, reactive, onMounted, defineComponent, toRefs  } from '@vue/composition-api'
var $Vue = Vue.prototype
import { useStore } from '../../pinia/stores.js'
import { storeToRefs } from 'pinia';



import {
  getTeachers,
  getStudents,
  getStudentscopy,
} from "@/api/firstClassApi";

import {  getStudentsType } from "@/api/fiveClassApi"

export default defineComponent({
  props: {
    DetailsRow: Object,
    TimeList: Array,
    isNewClassType:Number || String ,
  },
  setup(props, { attrs, slots, emit, expose  }){
    const coursecancellationStatus = reactive([{ id: '', realname: '全部'},{ id: 0, realname: '未课消'},{ id: 1, realname: '已课消'}])
    let coursecancellationStatusInput = ref('')
    let dataTop_s = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let requestParameters = reactive({ pageSize: 10,  pageNum: 1, total: 0, })
    let dataList = ref([])
    let curriculumArr = ref([])
    let getStudentsArr = ref([])
    let getStudentsArr_s = ref([])
    let dateTimeList = ref([])
    let TimeList = ref([])
    let student = ref("")
    let student_s = ref("")
    let curriculum = ref("")
    let teacherId = ref("")


    let newClassType =  ref('')
    let newClassTypeList = ref([
      { id:1, name:'规划'},
      { id:2, name:'线下'},
      { id:3, name:'纯补课'},
    ])

    const store = useStore()
    // const { teacherName } = storeToRefs(store.row)
    const rowObj = storeToRefs(store.row)

    onMounted(()=>{

      TimeList.value = props.TimeList

      newClassType.value = props.isNewClassType

      teacherId.value = rowObj.teacherId.value


      handleSelectAll()

     if(TimeList.value){
        dateTimeList.value = TimeList.value
        let data = {
          pageSize: 10,
          pageNo: 1,
          startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
          endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
          teacherId: teacherId.value ? teacherId.value : null,
          isSales: coursecancellationStatusInput.value,
          classType: newClassType.value ? newClassType.value : '',
          channelType: rowObj.channelType.value,
        }

        getListData(data)
     }else{
        let data = {
          pageSize: 10,
          pageNo: 1,
          teacherId: teacherId.value ? teacherId.value : null,
          isSales: coursecancellationStatusInput.value,
          classType: newClassType.value ? newClassType.value : '',
        }

        getListData(data)
     }

    })


    const handleSelectAll = () =>{

     axios.get(`${apiBaseUrl}/schedule/categorylist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
        curriculumArr.value = response.data.data
     }).catch(error => { console.error(error)})
    //  getStudentsType(2).then((res) => {  getStudentsArr.value = res.data })
    //  getStudentsType(1).then((res) => {  getStudentsArr_s.value = res.data })

     getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr.value = res.data })
     getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_s.value = res.data })
    }


    const studentChange222 = (e) => {
      if(e){
      }else{
        getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr.value = res.data })
      }
    }

    const handleInput222 = (e) => {
      getStudentscopy({studentType: 2, state: 1,  realname: e,}).then((res) => {  getStudentsArr.value = res.data })
    }


    const studentChange22 = (e) => {
      if(e){
      }else{
        getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr_s.value = res.data })
      }
    }

    const handleInput22 = (e) => {
      getStudentscopy({studentType: 2, state: 1,  realname: e,}).then((res) => {  getStudentsArr_s.value = res.data })
    }

    const exportBtns = () => {
      // const data = [
      //   ["姓名", "年龄", "职业"],
      //   ["Alice", 28, "Engineer"],
      //   ["Bob", 22, "Designer"]
      // ];
      // ExportExcel(data)

      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }


      let data = {
          categoryId: curriculum.value,
          startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
          endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
          teacherId: teacherId.value,
          studentIds: str,
          isSales: coursecancellationStatusInput.value,
      }


      axios.post(`${apiBaseUrl}/classSales/excelClassSalesInfo`, data, { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
        if(response.status == 200){
           const blob = new Blob([response.data], { type: "application/vnd.ms-excel",});
           const downloadLink = document.createElement("a");
           downloadLink.href = URL.createObjectURL(blob);
           downloadLink.download = "课消详情统计.xlsx";
           downloadLink.click();
           handleMessage('导出成功', 'success')
        }else{
           handleMessage('导出失败', 'error')
        }
      })

    }

    const searchBtns = () =>{
      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }

      if(dateTimeList.value){
        let data = {
          pageSize: 10,
          pageNo: 1,
          categoryId: curriculum.value,
          startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
          endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
          teacherId: teacherId.value,
          studentIds: str,
          isSales: coursecancellationStatusInput.value,
          classType: newClassType.value ? newClassType.value : '',
        }
        getListData(data)
      }else{
        let data = {
          pageSize: 10,
          pageNo: 1,
          categoryId: curriculum.value,
          teacherId: teacherId.value,
          studentIds: str,
          isSales: coursecancellationStatusInput.value,
          classType: newClassType.value ? newClassType.value : '',
        }
        getListData(data)
      }
    }

    const clearBtns = () =>{
      getStudentscopy({studentType: 2, state: 1,  realname: '',}).then((res) => {  getStudentsArr.value = res.data })
      getStudentscopy({studentType: 1, state: 1,  realname: '',}).then((res) => {  getStudentsArr_s.value = res.data })

      // dateTimeList.value = []
      curriculum.value = ""
      student.value  = ""
      student_s.value  = ""
      coursecancellationStatusInput.value = ""
      newClassType.value = ""
      if(dateTimeList.value){
        let data = {
          pageSize: 10,
          pageNo: 1,
          startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
          endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
          teacherId: teacherId.value ? teacherId.value : null,
          isSales: coursecancellationStatusInput.value,
          classType: newClassType.value ? newClassType.value : '',
        }

        getListData(data)
      }else{
        let data = {
          pageSize: 10,
          pageNo: 1,
          teacherId: teacherId.value ? teacherId.value : null,
          isSales: coursecancellationStatusInput.value,
          classType: newClassType.value ? newClassType.value : '',
        }

        getListData(data)
      }
    }


    const getListData = (data = {
      classType: newClassType.value ? newClassType.value : '',
      startTime: dateTimeList.value[0] ? dateTimeList.value[0] : TimeList.value[0],
      endTime: dateTimeList.value[1] ? dateTimeList.value[1] : TimeList.value[1],
      isSales: coursecancellationStatusInput.value,
      pageSize: requestParameters.pageSize, pageNo: requestParameters.pageNum, teacherId: teacherId.value ? teacherId.value : null }) =>{
      data.categoryInfoIds =  rowObj.courseCategoryIds.value
      data.channelType = rowObj.channelType.value,

      axios.post(`${apiBaseUrl}/classSales/queryClassSalesInfo`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {

        let list = response.data
        if (list.code == 200) {
              requestParameters.total = list.data.allTotal
              requestParameters.pageNum = list.data.pageIndex
              dataList.value = list.data.classSales
              dataTop_s.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
              dataTop_s.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
              dataTop_s.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
              dataTop_s.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
              dataTop_s.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
              dataTop_s.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0

              handleMessage('课消详情查询成功', 'success')
          }else{
              handleMessage('课消详情查询失败', 'error')
        }
        })
        .catch(error => {
          handleMessage('查询失败','error')
          console.error(error);
        });
    }

    const handleSizeChange = (pageSize) => {
      requestParameters.pageSize = pageSize;
      getListData();
    }

    const handleCurrentChange  = (newPage) => {
      requestParameters.pageNum = newPage;
      getListData();
    }

    const handleMessage = (message,type) =>{
       $Vue.$message({ message, type, duration: 500 });
    }


    const handleReturn = () =>{
       emit('handleEmitButs', false, 'bomm')
    }


    return {
      curriculumArr,
      getStudentsArr,
      getStudentsArr_s,
      dateTimeList,
      curriculum,
      student,
      student_s,
      dataList,
      requestParameters,

      handleSelectAll,
      exportBtns,
      searchBtns,
      getListData,
      handleSizeChange,
      handleCurrentChange,
      handleMessage,
      handleReturn,
      clearBtns,
      dataTop_s,
      coursecancellationStatus,
      coursecancellationStatusInput,

      newClassTypeList,
      newClassType,

      studentChange222,
      handleInput222,
      studentChange22,
      handleInput22,

    }
  },

})

</script>

<style scoped>

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
.el-form-item__label{
  width: 100px;
}

</style>



// WEBPACK FOOTER //
// src/manager/createComponents/CourseSalesStatisticsDetails.vue